<template>
<div class="chapter">
<div class="inner_page">
<h1 class="sigil_not_in_toc" id="toc_marker-2"></h1>
<h2 id="sigil_toc_id_5">Contents</h2>
<p class="firstleft"><br/></p>
<p class="firstleft"><a href="#/Text/prologue">Prologue: <i>King’s Wittenberg Moment</i></a></p>
<blockquote>
<p class="left"><a href="#/Text/ch1">1 Birmingham Begins</a></p>
<p class="firstleft"><span href="#/Text/ch2" title="Link target outside of Sample">2 The Making of Martin</span></p>
<p class="firstleft"><span href="#/Text/ch3" title="Link target outside of Sample">3 Montgomery Miracle</span></p>
<p class="firstleft"><span href="#/Text/ch4" title="Link target outside of Sample">4 The Road to Revolution</span></p>
<p class="firstleft"><span href="#/Text/ch5" title="Link target outside of Sample">5 As Birmingham Goes</span></p>
<p class="firstleft"><span href="#/Text/ch6" title="Link target outside of Sample">6 Eight White Preachers, or With Friends Like These</span></p>
<p class="firstleft"><span href="#/Text/ch7" title="Link target outside of Sample">7 An Angry Dr. King</span></p>
<p class="firstleft"><span href="#/Text/ch8" title="Link target outside of Sample">8 The Jailhouse Manifesto</span></p>
<p class="firstleft"><span href="#/Text/ch9" title="Link target outside of Sample">9 “My Dear Fellow Clergymen”</span></p>
<p class="firstleft"><span href="#/Text/ch10" title="Link target outside of Sample">10 Taking It to the Streets</span></p>
<p class="firstleft"><span href="#/Text/ch11" title="Link target outside of Sample">11 Dreams and Nightmares</span></p>
<p class="firstleft"><span href="#/Text/ch12" title="Link target outside of Sample">12 After the Revolution</span></p>
<p class="firstleft"><span href="#/Text/ch13" title="Link target outside of Sample">13 King Among the Evangelicals</span></p>
</blockquote>
<p class="firstleft"><span href="#/Text/epilogue" title="Link target outside of Sample">Epilogue: <i>King’s Epistle for Today</i></span></p>
<p class="firstleft"><span href="#/Text/acknowledgments" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="firstleft"><span href="#/Text/notes" title="Link target outside of Sample">Notes</span></p>
<p class="firstleft"><span href="#/Text/morereading" title="Link target outside of Sample">Recommended Reading on Race, MLK and the Civil Rights Movement</span></p>
<p class="firstleft"><span href="#/Text/index" title="Link target outside of Sample">Index</span></p>
<p class="firstleft"><span href="#/Text/discussionguide" title="Link target outside of Sample">Discussion Guide for <i>Birmingham Revolution</i></span></p>
<p class="firstleft"><span href="#/Text/endorsements" title="Link target outside of Sample">Praise for <i>Birmingham Revolution</i></span></p>
<p class="firstleft"><span href="#/Text/aboutauthor" title="Link target outside of Sample">About the Author</span></p>
<p class="firstleft"><span href="#/Text/morefromIVP" title="Link target outside of Sample">More Titles from InterVarsity Press</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?7165c5a6